document.addEventListener("alpine:init", () => {
  Alpine.data("guideChapters", () => ({
    positionTop: 0,
    lastScrollTop: 0,
    navBar: null,
    currentLink: null,
    init() {
      this.navBar = this.$el;

      const navLinks = this.$refs.navLinks.querySelectorAll("li");

      this.currentLink = navLinks[0].querySelector("a").getAttribute("href");

      this.checkPosition(true);
    },
    checkPosition(onLoad = false) {
      const contentRows = document.querySelectorAll(".Guide__Content [id]");
      const windowOffset = window.outerHeight / 2;

      contentRows.forEach((row) => {
        if (typeof row.id === "undefined" || row.id === null || row.id === "") {
          return false;
        }
        const rowTop = pegasus.getElemOffset(row).top,
          rowBottom = pegasus.getElemOffset(row).bottom;

        let st = window.scrollY;

        if (onLoad) {
          if (
            window.scrollY + windowOffset >= rowTop &&
            window.scrollY + windowOffset <= rowBottom
          ) {
            this.currentLink = "#" + row.id;
          }
        }

        if (st >= this.lastScrollTop) {
          //Scroll Down
          if (
            window.scrollY + windowOffset >= rowTop &&
            window.scrollY + windowOffset <= rowBottom
          ) {
            this.currentLink = "#" + row.id;
          }
        } else {
          //Scroll Up
          if (
            window.scrollY - windowOffset <= rowBottom &&
            window.scrollY - windowOffset >= rowTop
          ) {
            this.currentLink = "#" + row.id;
          }
        }

        this.lastScrollTop = st;
      });

      if (window.scrollY <= this.positionTop.top) {
        const allLinks = this.$refs.navLinks.querySelectorAll("a");

        this.currentLink = allLinks[0].getAttribute("href");
      }
    },
  }));
});
